// extracted by mini-css-extract-plugin
export default {"home":"style_home__KvW99","home_container":"style_home_container__WOm0H"};